<template>
  <top-nav-component></top-nav-component>
  <div class="w-full max-w-full container flex items-stretch flex-col w-full sm:flex-row">
    <div>
      <side-nav-component></side-nav-component>
    </div>
    <div class="w-full mr-6 sm:ml-6">
      <div class="mt-3">
        <breadcrumbs-component></breadcrumbs-component>
      </div>
      <div class="main-content bg-white w-full mt-3 rounded px-8 py-6">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SideNavComponent from '../navigation/SideNavComponent.vue';
import TopNavComponent from '../navigation/TopNavComponent.vue';
import BreadcrumbsComponent from '../navigation/Breadcrumbs.vue';

export default defineComponent({
  name: 'UserLayout',
  components: {
    TopNavComponent,
    SideNavComponent,
    BreadcrumbsComponent,
  },
});
</script>

<style scoped>
.container {
  min-height: calc(100% - 60px);
}

.main-content {
  min-height: 300px;
  box-shadow: 0 1rem 3rem rgb(0 0 0 /18%);
}

::v-deep(.el-loading-spinner) {
  left: 50%;
}
</style>
